<!--
 * @Author: hxz
 * @Date: 2023-04-20 10:12:34
 * @LastEditors: hxz
 * @LastEditTime: 2023-04-27 16:09:20
 * @Description: 
-->
<template>
  <div>
    <img
      class="brand"
      src="https://lndxappcdn.jinlingkeji.cn/brand/branding.png"
    />
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.brand {
  width: 100%;
  height: 854vw;
}
</style>
